import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { debounce } from 'lodash';
import { Stage } from 'react-konva';
import Game from '../../Game';
import detectOrientation, { Orientation } from '../../../utils/detectOrientation';

const useStyles = makeStyles(theme => ({
  app: {
    position: 'relative',
    fontSize: 22,
    [theme.breakpoints.up('md')]: {
      display: 'flex',
    },
  },
  navigation: {
    zIndex: 30,
    position: 'relative',
    width: theme.spacing(24),
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(2),
    },

    [theme.breakpoints.down('md')]: {},
  },
  content: {
    zIndex: 300,
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    overflow: 'hidden',
    [theme.breakpoints.up('md')]: {
      maxWidth: 720,
      width: '100%',
      margin: '0 auto',
    },
    [theme.breakpoints.up('lg')]: {
      maxWidth: 820,
    },
    [theme.breakpoints.up('xl')]: {
      maxWidth: 1200,
    },
  },
}));

interface IProps {
  nav: React.ReactNode;
  onResize: (orientation: Orientation, contentWidth: number) => void;
  gameRef: (stage: any) => null;
  size: number;
}

const Container: React.FC<IProps> = ({ size, gameRef, onResize, nav }) => {
  const classes = useStyles();
  const contentRef = React.useRef<any>(null);
  const height = React.useMemo(() => Math.max(size * 0.9, window.screen.availHeight), [size]);
  const desktopMQL = matchMedia('(min-width: 1024px)');
  const portraitMQL = window.matchMedia('(orientation: portrait)');

  const onCallback = debounce(() => {
    const orientation = detectOrientation(desktopMQL.matches, portraitMQL.matches);
    onResize(orientation, contentRef.current.clientWidth);
  }, 150);

  React.useEffect(() => {
    onCallback();
    window.addEventListener('resize', onCallback);
    desktopMQL.addEventListener('change', onCallback);
    portraitMQL.addEventListener('change', onCallback);

    return () => {
      window.removeEventListener('resize', onCallback);
      desktopMQL.removeEventListener('change', onCallback);
      portraitMQL.removeEventListener('change', onCallback);
    };
  }, [contentRef, onResize]);

  return (
    <div className={classes.app} id="App">
      <div className={classes.navigation}>{nav}</div>
      <div id="content" ref={contentRef} className={classes.content}>
        <Stage width={size} height={height} ref={gameRef}>
          <Game />
        </Stage>
      </div>
    </div>
  );
};
export default React.memo(Container);
